import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { WefitSsoService } from '../sso/wefit-sso.service';

export interface WefitTrainingProgram {
  tp_id: number;
  tp_name: string;
  formation_id: number;
  formation: string;
  formation_code: string;
  method_id: number;
  method_alias: string;
  method: string;
  status: string;
  status_id: number;
  date_start: string;
  date_end: string;
  duration_minutes: number;
  duration_hours: string;
  elearning_name: string;
}

const PARTNER_API_URL = 'https://lms.wefitgroup.com/auth/partner_api.cfm?action=get_user_tps';

@Injectable({
  providedIn: 'root'
})
export class WefitPartnerService {

  // HttpClient instancié depuis HttpBackend pour bypasser les intercepteurs GS
  private readonly http: HttpClient;

  constructor(
    handler: HttpBackend,
    private wefitSsoSrv: WefitSsoService
  ) {
    this.http = new HttpClient(handler);
  }

  /**
   * Fetches the user's training programs from the Wefit partner API.
   * Returns null if the token is missing or the call fails.
   */
  async getTrainingPrograms(): Promise<WefitTrainingProgram[] | null> {
    const token = await this.wefitSsoSrv.getToken();
    if (!token) {
      return null;
    }

    try {
      const result: any = await this.http.get(PARTNER_API_URL, {
        headers: new HttpHeaders({ Authorization: `Bearer ${token}` })
      }).toPromise();

      if (result?.success && Array.isArray(result?.data?.training_programs)) {
        return result.data.training_programs;
      }
      return null;
    } catch (e) {
      console.warn('GS: Wefit partner API unavailable', e?.message);
      return null;
    }
  }

  /**
   * Returns the lowercase GS language codes the user has access to.
   * Returns null if the API call fails (use fallback in caller).
   */
  async getAccessibleLangCodes(): Promise<string[] | null> {
    const tps = await this.getTrainingPrograms();
    if (!tps) {
      return null;
    }
    return [...new Set(tps.map(tp => tp.formation_code.toLowerCase()))];
  }
}
